// Styles
import './Header.css'

// Components
import HeaderLogo from './HeaderLogo'

const Header = () => {
  return (
    <div className='Header'>
        <HeaderLogo />
    </div>
  )
}

export default Header